// extracted by mini-css-extract-plugin
export var container = "_5a-1";
export var cornerButtonContainer = "_5a-6";
export var disabled = "_5a-2";
export var dragActive = "_5a-3";
export var fileContainer = "_5a-5";
export var hiddenInput = "_5a-4";
export var widthContainer = "_5a-0";